import axiosHandler from "./axiosHandler";
import {
  showSnackbarAction,
  setLockSideNavbar,
  setSystemMessagesActivated
} from "../Redux/actions";
import { upsateIsSystemMessagesActivated } from "../Services/organizations";
import { getDateWithOffset } from "../Values/utils";
import { Dispatch, SetStateAction } from "react";

const getDateOnly = (date:Date|null) => {
  if (date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`; // Format: YYYY-MM-DD
  }else{
    return "";
  }
}

export const fetchAllCampaigns = async (
  organization_id: string,
  page: number,
  limit: number,
  setCampaignData: any,
  setTotalCount: any,
  startDate: Date|null,
  endDate: Date|null,
  activeMarketTab: string,
  // setDownloadHeaders: any,
  // setDownloadData: any
) => {
  try {
    let apiData: any = {
      organization_id,
      page,
      limit,
      startDate: getDateOnly(startDate),
      endDate: getDateOnly(endDate),
    };

    let apiUrl = activeMarketTab === "Broadcast Message" ? "/marketingAutomation/fetchCampaignReport" : "/marketingAutomation/fetchSystemTriggeredMessagesReport";
    const res = await axiosHandler.get(
      apiUrl,
      {
        params: apiData,
      }
    );
    let campaignData = res?.data?.paginatedData ? res.data.paginatedData : [];
    setCampaignData(campaignData);
    setTotalCount(res.data.totalCount);
    return;
  } catch (error: any) {
    setCampaignData([]);
    return;
  }
};

export const fetchBrowseTemplate = async (SelectedTab: any, page: number, setTotalCount: React.Dispatch<React.SetStateAction<number>>) => {
  try {
    // let selectedCategory =''
    // if(SelectedTab === 'tab1'){
    //   selectedCategory = "pre_launch"
    // }
    // else if(SelectedTab === 'tab2'){
    //   selectedCategory = "offers"
    // }
    // else{
    //   selectedCategory = "generic"
    // }
    let apiData: any = {
      template_type: "Broadcast",
      category: SelectedTab,
      page: page,
      limit: 5
    };
    const res = await axiosHandler.get(
      "marketingAutomation/fetchAllSubcategories",
      {
        params: apiData,
      }
    );
    const templatesDataArray = [];
    setTotalCount(res.data.totalCount);
    let obj = res.data.data;
    for (let key in obj) {
      // if (obj[key] != null) {
        templatesDataArray.push({
          [key]: obj[key],
        });
      // }
    }
    return templatesDataArray
    // if (SelectedTab === "Pre Launch") {
    //   const templatesDataArray = [];
    //   let obj = res.data.data;
    //   for (let key in obj) {
    //     templatesDataArray.push({
    //       [key]: obj[key],
    //     });
    //   }
    //   return templatesDataArray
    // } else if (SelectedTab === "Offers") {
    //   const templatesDataArray = [];
    //   let obj = res.data.data;
    //   for (let key in obj) {
    //     templatesDataArray.push({
    //       [key]: obj[key],
    //     });
    //   }
    //   return templatesDataArray
    // } else {
    //   const templatesDataArray = [];
    //   let obj = res.data.data;
    //   for (let key in obj) {
    //     templatesDataArray.push({
    //       [key]: obj[key],
    //     });
    //   }
    //   return templatesDataArray
    // }
  } catch (error: any) {
    return;
  }
};

export const fetchDispositionTemplates = async (
  selectedTab: any,
  selectedTemplatesType: string,
  page: Number,
  pageSize: Number,
  setTotalCount: Dispatch<SetStateAction<number>>,
  setDispositionTemplates?: any
) => {
  try {
    // const res = await axiosHandler.get('/marketingAutomation/fetchAllSubcategories');
    // setTemplatesData(res.data.data);
    // return res.data.data;

    // let selectedCategory =''
    // if(SelectedTab === 'tab1'){
    //   selectedCategory = "pre_launch"
    // }
    // else if(SelectedTab === 'tab2'){
    //   selectedCategory = "offers"
    // }
    // else{
    //   selectedCategory = "generic"
    // }
    let template_type =
      selectedTemplatesType == "Disposition based"
        ? "System"
        : "Broadcast";
    // console.log("REDWS",template_type,selectedTab)
    let apiData: any = {
      template_type: template_type,
      category: selectedTab,
      page,
      limit: pageSize
    };
    const res = await axiosHandler.get(
      "marketingAutomation/fetchAllSubcategories",
      {
        params: apiData,
      }
    );
    const templatesDataArray = [];
    setTotalCount(res.data.totalCount);
    let obj = res.data.data;
    for (let key in obj) {
      templatesDataArray.push({
        [key]: obj[key],
      });
    }
    // setDispositionTemplates(templatesDataArray);
    return templatesDataArray;

    // console.log("res data nm",res.data.data,templatesDataArray);
    // return templatesDataArray;
  } catch (error: any) {
    console.error(
      "Error during fetching disposition templates:",
      error.message
    );
    // setDispositionTemplates([]);
    return;
  }
};

export const stringManipulateData = async (
  templateData: any,
  selectedDropDownValue: any,
  campType: any
) => {
  try {
    let selectedValue: any = {};
    if (campType === "Contacts") {
      selectedDropDownValue.forEach((element: any, index: any) => {
        selectedValue[index + 1] = element;
      });
    } else if (campType === "Excel") {
      selectedDropDownValue.forEach((element: any, index: any) => {
        selectedValue[index + 1] = element.value;
      });
    }

    const res = await axiosHandler.post(
      "marketingAutomation/templateManipulation",
      {
        msgContent: templateData?.MSG_CONTENT,
        msg_variable_count: templateData?.MSG_VAR_COUNT,
        values: selectedValue,
      }
    );
    return res?.data;
  } catch (error: any) {
    return;
  }
};

export const getUniqueLeadCount = async (
  created_at: any,
  project_name: any,
  property_type: any,
  budget: any,
  lead_source: any,
  lead_type: any,
  lead_assigne: any,
  requirement_type:any,
  user: any
) => {
  try {
    let filters = {
      budget: budget[0] === undefined ? undefined : budget,
      contact_owner_email: lead_assigne.length === 0 ? undefined : lead_assigne,
      lead_source: lead_source.length === 0 ? undefined : lead_source,
      lead_type: lead_type.length === 0 ? undefined : lead_type,
      project: project_name.length === 0 ? undefined : project_name,
      property_type: property_type.length === 0 ? undefined : property_type,
      created_at: created_at ? created_at : undefined,
      requirement_Type:requirement_type?[requirement_type]:undefined
    };

    let apiData: any = {
      filters: filters,
      organization_id: user.organization_id,
    };
    const res = await axiosHandler.get(
      "marketingAutomation/fetchUniqueLeadsCount",
      {
        params: apiData,
      }
    );
    return res.data.data;
  } catch (error: any) {
    return;
  }
};

export const createCampaign = async (
  campName:any,
  templateData: any,
  user: any,
  campType: any,
  excelUrl: any,
  browseContactData: any,
  excelTemplateHeader: any,
  scheduleTogelActive: any,
  camStatus: any,
  selectedDropDownValue: any,
  scheduleDate: any,
  scheduleTime: any,
  totalReciptent:any,
  excelContact:any,
) => {
  try {
    let selectedValue: any = {};
    let formattedTime: any = "";
    let formattedDate: any = "";
    if (campType === "Contacts") {
      selectedDropDownValue.forEach((element: any, index: any) => {
        selectedValue[index + 1] = element?element:null;
      });
    } else if (campType === "Excel") {
      selectedDropDownValue.forEach((element: any, index: any) => {
        selectedValue[index + 1] = element?.value?element.value:null;
      });
    }

    if (scheduleTogelActive === false) {
      const todayDate = new Date();

      todayDate.setMinutes(todayDate.getMinutes() + 10);

      formattedDate = todayDate.toISOString().slice(0, 10);
      const hours = todayDate.getHours().toString().padStart(2, "0");
      const minutes = todayDate.getMinutes().toString().padStart(2, "0");
      formattedTime = `${hours}:${minutes}`;
    }

    let projectName: any = [];
    let propertyType: any = [];
    let Budget: any = [browseContactData?.budgetFromSelected?.value,browseContactData?.budgetToSelected?.value];
    let leadSource: any = [];
    let leadType: any = [];
    let leadAssigne: any = [];
    if (browseContactData?.projectNameSelected?.length !== 0) {
      browseContactData?.projectNameSelected?.forEach((element: any) => {
        projectName.push(element.value);
      });
    }
    if (browseContactData?.propertyTypeSelected?.length !== 0) {
      browseContactData?.propertyTypeSelected?.forEach((element: any) => {
        propertyType.push(element.value);
      });
    }
    // if (browseContactData?.budgetSelected?.length !== 0) {
    //   browseContactData?.budgetSelected?.forEach((element: any) => {
    //     Budget.push(element.value);
    //   });
    // }
    if (browseContactData?.leadSourceSelected?.length !== 0) {
      browseContactData?.leadSourceSelected?.forEach((element: any) => {
        leadSource.push(element.value);
      });
    }
    if (browseContactData?.leadTypeSelected?.length !== 0) {
      browseContactData?.leadTypeSelected?.forEach((element: any) => {
        leadType.push(element.value);
      });
    }
    if (browseContactData?.leadAssigneeSelected?.length !== 0) {
      browseContactData?.leadAssigneeSelected?.forEach((element: any) => {
        leadAssigne.push(element.value);
      });
    }
    const res = await axiosHandler.post("/marketingAutomation/createCampaign", {
      WATID: templateData?.WATID ? templateData.WATID : null,
      OTID: templateData?.OTID ? templateData.OTID : null,
      ORGANIZATION_ID: user.organization_id,
      CAMPAIGN_NAME: campName === ""
        ? null
        : campName,
      CREATEDBY: user.uid,
      PLACEHOLDER_PARAMS: Object.keys(selectedValue).length === 0? null : selectedValue,
      SCHEDULE_TYPE: scheduleTogelActive === true ? "Scheduled" : "Immediate",
      SCHEDULED_AT:
      camStatus === "Draft"?null:
        scheduleTogelActive === false
          ? `${formattedDate}-${formattedTime}`
          : `${scheduleDate}-${scheduleTime}`,
      CAMPAIGN_STATUS: camStatus,
      CAMPAIGN_TYPE: campType === ""?"Excel":campType,
      CAMPAIGN_FILE: excelUrl ? excelUrl : null,
      LEAD_FROM_DATE: browseContactData.fromDate,
      LEAD_TO_DATE: browseContactData.toDate,
      PROJECT_NAME: projectName,
      PROPERTY_TYPE: propertyType,
      RQUIREMENT_TYPE:browseContactData?.requirementTypeSelected?.value?[browseContactData?.requirementTypeSelected?.value]:[],
      BUDGET: Budget[0] === undefined ?[]:Budget,
      LEAD_SOURCE: leadSource,
      LEAD_TYPE: leadType,
      LEAD_ASSIGNEE: leadAssigne,
      EXTRACTED_HEADERS: excelTemplateHeader,
      uniqueCount:totalReciptent === ""?"0":totalReciptent,
      contactNumberFiled:excelContact === ""?null:excelContact.value,
      MSG_VAR_COUNT:templateData?.MSG_VAR_COUNT ? templateData.MSG_VAR_COUNT : null,
    });
    return res.data;
  } catch (error: any) {
    console.error("Error creating campaign:", error?.response);
    return error?.response?.data;
  }
}


export const createOrgDispositionConfig = async (
  organization_id: string,
  dispositionConfigArray: Array<object>,
  dispatcher: any,
  history: any,
  setShowSubmitButton?: any
) => {
  try {
    let is_disposition_whatsapp_active = false;
    dispositionConfigArray.forEach((disposition:any)=>{
      if(disposition.ISACTIVE == "Y"){
        is_disposition_whatsapp_active = true;
      }
    })
    // dispatcher(setSystemMessagesActivated(is_disposition_whatsapp_active));
    const response = await axiosHandler.post('/marketingAutomation/createOrgDispositionConfig', {
      organization_id,
      dispositionConfigArray
    });
    upsateIsSystemMessagesActivated(organization_id,is_disposition_whatsapp_active,dispatcher);
    setShowSubmitButton(false);
    dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        response?.data?.message ? response.data.message : "Success",
        "success"
      )
    );
    dispatcher(setLockSideNavbar({ lockSideNavbar: false }));
    history.push("/templates");
    return
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        error?.response?.data?.message ? error.response.data.message : "An error occured, please try again.",
        "error"
      )
    );
    return

  }
}

export const updateOrgDispositionConfig = async (
  organization_id: string,
  dispositionConfigArray: Array<object>,
  dispatcher: any,
  history: any,
  setShowSubmitButton?: any
) => {
  try {
    let is_disposition_whatsapp_active = false;
    dispositionConfigArray.forEach((disposition:any)=>{
      if(disposition.ISACTIVE == "Y"){
        is_disposition_whatsapp_active = true;
      }
    })
    // dispatcher(setSystemMessagesActivated(is_disposition_whatsapp_active));
    const response = await axiosHandler.post('/marketingAutomation/updateOrgDispositionConfig', {
      organization_id,
      dispositionConfigArray
    });
    upsateIsSystemMessagesActivated(organization_id,is_disposition_whatsapp_active,dispatcher);
    setShowSubmitButton(false);
    dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        response?.data?.message ? response.data.message : "Success",
        "success"
      )
    );
    // dispatcher(setLockSideNavbar({ lockSideNavbar: false }));
    history.push("/templates");
    return
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        error?.response?.data?.message ? error.response.data.message : "An error occured, please try again.",
        "error"
      )
    );
    return

  }
}


export const updateCampaign = async (
  campName:any,
  templateData: any,
  user: any,
  campType: any,
  excelUrl: any,
  browseContactData: any,
  excelTemplateHeader: any,
  scheduleTogelActive: any,
  camStatus: any,
  selectedDropDownValue: any,
  scheduleDate: any,
  scheduleTime: any,
  totalReciptent:any,
  excelContact:any,
  WACID:any
) => {
  try {
    let selectedValue: any = {};
    let formattedTime: any = "";
    let formattedDate: any = "";
    if (campType === "Contacts") {
      selectedDropDownValue.forEach((element: any, index: any) => {
        selectedValue[index + 1] = element;
      });
    } else if (campType === "Excel") {
      selectedDropDownValue.forEach((element: any, index: any) => {
        selectedValue[index + 1] = element.value;
      });
    }

    if (scheduleTogelActive === false) {
      const todayDate = new Date();

      todayDate.setMinutes(todayDate.getMinutes() + 10);

      formattedDate = todayDate.toISOString().slice(0, 10);
      const hours = todayDate.getHours().toString().padStart(2, "0");
      const minutes = todayDate.getMinutes().toString().padStart(2, "0");
      formattedTime = `${hours}:${minutes}`;
    }

    let projectName: any = [];
      let propertyType: any = [];
      let Budget: any = [browseContactData?.budgetFromSelected?.value,browseContactData?.budgetToSelected?.value];
      let leadSource: any = [];
      let leadType: any = [];
      let leadAssigne: any = [];
      if (browseContactData?.projectNameSelected?.length !== 0) {
        browseContactData?.projectNameSelected?.forEach((element: any) => {
          projectName.push(element.value);
        });
      }
      if (browseContactData?.propertyTypeSelected?.length !== 0) {
        browseContactData?.propertyTypeSelected?.forEach((element: any) => {
          propertyType.push(element.value);
        });
      }
      // if (browseContactData?.budgetSelected?.length !== 0) {
      //   browseContactData?.budgetSelected?.forEach((element: any) => {
      //     Budget.push(element.value);
      //   });
      // }
      if (browseContactData?.leadSourceSelected?.length !== 0) {
        browseContactData?.leadSourceSelected?.forEach((element: any) => {
          leadSource.push(element.value);
        });
      }
      if (browseContactData?.leadTypeSelected?.length !== 0) {
        browseContactData?.leadTypeSelected?.forEach((element: any) => {
          leadType.push(element.value);
        });
      }
      if (browseContactData?.leadAssigneeSelected?.length !== 0) {
        browseContactData?.leadAssigneeSelected?.forEach((element: any) => {
          leadAssigne.push(element.value);
        });
      }

    const res = await axiosHandler.put("/marketingAutomation/editCampaign", {
      WACID:WACID,
      CAMPAIGN_STATUS: camStatus,
      uniqueCount:totalReciptent === ""?"0":totalReciptent,
      organization_id: user.organization_id,
      MSG_VAR_COUNT:templateData?.MSG_VAR_COUNT ? templateData.MSG_VAR_COUNT : null,
      WATID: templateData?.WATID ? templateData.WATID : null,
      OTID: templateData?.OTID ? templateData.OTID : null,
      updateObj:{
        CAMPAIGN_STATUS: camStatus,
        WATID: templateData?.WATID ? templateData.WATID : null,
        OTID: templateData?.OTID ? templateData.OTID : null,
        CAMPAIGN_NAME: campName === ""
          ? null
          : campName,
        CREATEDBY: user.uid,
        PLACEHOLDER_PARAMS: Object.keys(selectedValue).length === 0? null : selectedValue,
        SCHEDULE_TYPE: scheduleTogelActive === true ? "Scheduled" : "Immediate",
        SCHEDULED_AT:camStatus === "Draft"?null:
          scheduleTogelActive === false
            ? `${formattedDate}-${formattedTime}`
            : `${scheduleDate}-${scheduleTime}`,
        CAMPAIGN_TYPE: campType === ""?"Excel":campType,
        CAMPAIGN_FILE: excelUrl ? excelUrl : null,
        LEAD_FROM_DATE: browseContactData.fromDate?browseContactData.fromDate:null,
        LEAD_TO_DATE: browseContactData.toDate?browseContactData.toDate:null,
        PROJECT_NAME: projectName,
        PROPERTY_TYPE: propertyType,
        RQUIREMENT_TYPE:browseContactData?.requirementTypeSelected?.value?[browseContactData?.requirementTypeSelected?.value]:[],
        BUDGET: Budget[0] === undefined ?[]:Budget,
        LEAD_SOURCE: leadSource,
        LEAD_TYPE: leadType,
        LEAD_ASSIGNEE: leadAssigne,
        EXTRACTED_HEADERS: excelTemplateHeader,
        contactNumberFiled:excelContact === ""?null:excelContact.value,
        LEAD_COUNT:totalReciptent === ""?"0":totalReciptent,
      }
    });
    return res.data;
  } catch (error: any) {
    console.error("Error creating campaign:", error.response);
    return error.response.data;
  }
}


export const testMessageTrigget = async (
  sampleContact:any,
  templateData:any,
  campType:any,
  selectedDropDownValue: any,
  excelFirstRow:any,
  user:any,
  resWACID:any,
  draftData?:any,
) => {
 try {
  let selectedValue: any = {};
  if (campType === "Contacts") {
    // let obj:any={}
    // selectedDropDownValue.forEach((element: any, index: any) => {
    //   obj[element] = element;
    // });
    selectedValue={1:selectedDropDownValue};
  } else if (campType === "Excel") {
    selectedValue = Object.values(excelFirstRow).reduce((acc:any, value, index) => {
      acc[(index + 1).toString()] = value;
      return acc;
  }, {});
  }
  const res = await axiosHandler.post("/marketingAutomation/testTrigger", {
    contact_no:sampleContact,
    template_id:templateData?.WATID,
    OTID: templateData?.OTID,
    userobj:selectedValue,
    organization_id:user.organization_id,
    WACID:(resWACID===undefined||resWACID==="")? draftData?.WACID:resWACID,
    USER_NAME:`${user?.user_first_name} ${user?.user_last_name}`,
  });
  return res?.data;
 } catch (error:any) {
  return error.response.data;
 }
}

export const deleteCampaign = async (
user:any,
deletedData:any,
) => {
  try {

    const res = await axiosHandler.put("/marketingAutomation/editCampaign", {
      organization_id:user?.organization_id,
      WACID:deletedData?.WACID,
      isDelete:true,
      CAMPAIGN_STATUS:deletedData?.CAMPAIGN_STATUS,
      DB_SCHEDULE_AT:deletedData?.SCHEDULED_AT,
    });
    return res.data;
  } catch (error: any) {
    console.error("Error creating campaign:", error.response);
    return error.response.data;
  }
}

export const updateCampaignTime = async (
  user:any,
  updateData:any,
  scheduleTogelActive:any,
  scheduleDate:any,
  scheduleTime:any
  ) => {
    try { 
      let formattedTime: any = "";
      let formattedDate: any = "";
      if (scheduleTogelActive === false) {
        const todayDate = new Date();
  
        todayDate.setMinutes(todayDate.getMinutes() + 10);
  
        formattedDate = todayDate.toISOString().slice(0, 10);
        const hours = todayDate.getHours().toString().padStart(2, "0");
        const minutes = todayDate.getMinutes().toString().padStart(2, "0");
        formattedTime = `${hours}:${minutes}`;
      }
  
      const res = await axiosHandler.put("/marketingAutomation/editCampaign", {
        organization_id:user.organization_id,
        WACID:updateData.WACID,
        isShedule:true,
        DB_SCHEDULE_AT:updateData?.SCHEDULED_AT,
          updateObj:{
            SCHEDULE_TYPE: scheduleTogelActive === true ? "Scheduled" : "Immediate",
            SCHEDULED_AT:
            scheduleTogelActive === false
              ? `${formattedDate}-${formattedTime}`
              : `${scheduleDate}-${scheduleTime}`,
          }
      });
      return res.data;
    } catch (error: any) {
      console.error("Error creating campaign:", error.response);
      return error.response.data;
    }
  }


export const triggerWhatsappDispositionMessage = async (
  organization_id: string,
  disposition: string,
  sub_disposition: string,
  leadId: string,
  uid: string,
  date: string,
  project?: string,
) => {
  try {
    let apiData = {
      "ORGANIZATION_ID": organization_id,
      "DISPOSITION": disposition,
      "SUB_DISPOSITION": sub_disposition,
      "LEADID": leadId,
      "UID": uid,
      "DATE": date,
      "PROJECT": project
  }
  // console.log("apiData", apiData);
  // return;
    const res = await axiosHandler.post("/marketingAutomation/triggerWhatsappDispositionMessage", apiData);
    // console.log("Disposition Message Triggered", res.data);
    return;
  } catch (error) {
    // console.log("Disposition Message Trigger Unsuccessfull", error);
    return;
  }
}

export const isWAAgentActive = async (
  ORGANIZATION_ID: string,
  setBroadRates: (data: any) => void,
  setAgentModerationStatus: (data: string) => void,
) => {
  try {
    let params: any = {
      ORGANIZATION_ID
    };
    const res = await axiosHandler.get(
      "marketingAutomation/isWAAgentActive",
      {
        params,
      }
    );
    let isActive = res.data.data.status;
    let moderationStatus = res.data.data.moderationStatus ? res.data.data.moderationStatus : "";
    setAgentModerationStatus(moderationStatus);
    if( res.data.data.broadRate && res.data.data.broadRate!==""){
      setBroadRates(res.data.data.broadRate)
    }else{
      // res.data.data.broadRate("")
      setBroadRates("");
    }
    return isActive;
  } catch (error: any) {
    console.log("errorrrttt",error)
    return "";
  }
};

export const hasActiveWAPackage = async (
  SOID: string,
) => {
  try {
    let params: any = {
      SOID
    };
    const res = await axiosHandler.get(
      "marketingAutomation/hasActiveWAPackage",
      {
        params,
      }
    );
    return res.data.data.response;
  } catch (error: any) {
    return null;
    // return "INACTIVE";
  }
};

export const fetchSingleTemplate = async (
  selectedTemplateId: any, templateIdType: string
) => {
  try {
    let params = templateIdType === "WATID" ? {
      WATID: selectedTemplateId
    } : {
      OTID: selectedTemplateId
    }
    const res = await axiosHandler.get("/marketingAutomation/fetchSingleTemplate", {
      params: params
    });
    console.log("res", res.data.tempData[0]);
    return res.data.tempData[0]
  } catch (error) {
    console.log("error", error);
  }
}

export const searchTemplate = async (
  searchQuery:any,
  activeTab:any,
) => {
  try {
    const res = await axiosHandler.get("/marketingAutomation/searchCategories",  {
      params: {
        search:searchQuery,
        disposition:activeTab
      },
    });
    return res.data.data
  } catch (error) {
    console.log("error", error);
  }
}

export const fetchCampaignReportDateWise = async (
  organization_id: string,
  reportStartDate: string,
  reportEndDate: string,
  setDownloadHeaders: any,
  setDownloadData: any,
  activeMarketTab: string,
) => {
  try {
    let apiData: any = {
      organization_id,
      startDate: reportStartDate,
      endDate:reportEndDate,
      // startDate: getDateOnly(startDate),
      // endDate: getDateOnly(endDate),
      // type: activeMarketTab === "Broadcast Message" ? "Broadcast" : "System",
    };
    let apiUrl = activeMarketTab === "Broadcast Message" ? "/marketingAutomation/fetchCampaignReportDateWise" : "/marketingAutomation/fetchSystemTriggeredMessagesReportDateWise";
    const res = await axiosHandler.get(
      apiUrl,
      {
        params: apiData,
      }
    );
    let campaignData = res?.data?.paginatedData ? res.data.paginatedData : [];
    const headers = [];

    if (campaignData.length > 0) {
      let headerObj = campaignData[0];
      const allowedHeadersMapBroadcast:any = {
        "CAMPAIGN_NAME": "Campaign Name",
        "MESSAGE_PREVIEW": "Message Preview",
        "MSG_SENT_COUNT": "Sent",
        "MSG_DELIEVERED_COUNT": "Delievered",
        "MSG_READ_COUNT": "Read",
        "TOTAL_COUNT": "Total",
        "CREATEDBY": "Created By",
        "CAMPAIGN_STATUS": "Campaign Status",
        "CREATEDATE": " Created On",
        "CAMPAIGN_COST": "Campaign Cost (INR)",
      };
      const allowedHeadersMapSystem:any = {
        "DISPOSITION": "Stage",
        "SUB_DISPOSITION": "Sub Stage",
        "MESSAGE_PREVIEW": "Message Preview",
        "MSG_SENT_COUNT": "Sent",
        "MSG_DELIEVERED_COUNT": "Delievered",
        "MSG_READ_COUNT": "Read",
        "TOTAL_COUNT": "Total",
        "CAMPAIGN_COST": "Campaign Cost (INR)",
      };
      for (let key in headerObj) {
        // console.log("keua",key)
        if(activeMarketTab === "Broadcast Message"){
          if (allowedHeadersMapBroadcast[key]) {
            headers.push({ label: allowedHeadersMapBroadcast[key], key: `${key}` });
          }
        }else{
          if (allowedHeadersMapSystem[key]) {
            headers.push({ label: allowedHeadersMapSystem[key], key: `${key}` });
          }
        }
      }
      headers.push({ label: `Processed On`, key: `PROCESSED_ON` });
    }
    if(activeMarketTab === "Broadcast Message"){
      campaignData.forEach((item:any) => {
        item.CAMPAIGN_STATUS = (item.CAMPAIGN_STATUS === "New" || item.CAMPAIGN_STATUS === "Processing") 
          ? "Scheduled" 
          : item.CAMPAIGN_STATUS;
        item.CREATEDATE = getDateWithOffset(item.CREATEDATE, "dateAndTime");
        item.PROCESSED_ON = item.SCHEDULED_AT ? getDateWithOffset(item.SCHEDULED_AT, "dateAndTime",true) : getDateWithOffset(item.MODIDATE, "dateAndTime");
      });
    }else{
      campaignData.forEach((item:any) => {
        item.PROCESSED_ON = getDateWithOffset(item.CREATEDATE, "dateAndTime");
      });
    }
    
    // console.log("heafafsggs",headers,campaignData);
    setDownloadHeaders(headers);
    setDownloadData(campaignData);
    return;
  } catch (error: any) {
    return;
  }
};

export const manipulateString=(cleanContent:any,values:any)=>{
  
  try {
    let content:any=cleanContent.trim()
    for (const key in values) {

      const regex = new RegExp(`{{${key}}}`, 'g'); 
      if (values[key]) {
        let values1:any=values[key].toString().trim()
        const escapedValue = values1.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        content = content.replace(`{{${key}}}`, escapedValue);
      }
    }
    return content;

  } catch (error) {
    return ''
  }

}

export const fetchIsOrgDispositionActive = async (
  organization_id: string,
  dispatcher: any,
  setVendorMappingData: (data: any) => void 
) => {
  try {
    let params: any = {
      organization_id
    };
    const res = await axiosHandler.get(
      "marketingAutomation/fetchIsOrgDispositionActive",
      {
        params,
      }
    );
    setVendorMappingData(res.data.data);
    if(res.data.data.IS_DISPOSITION_ACTIVE == "Y"){
      // alert(" I ran");
      dispatcher(setSystemMessagesActivated(true));
      return;
    }else{
      dispatcher(setSystemMessagesActivated(false));
      return;
    }
  } catch (error: any) {
    dispatcher(setSystemMessagesActivated(false));
    return;
    // return "INACTIVE";
  }
};

export const canAccessMarketingAutomationModule = async (
  ORGANIZATION_ID: string,
) => {
  try {
    let params: any = {
      ORGANIZATION_ID
    };
    const res = await axiosHandler.get(
      "marketingAutomation/canAccessMarketingAutomationModule",
      {
        params,
      }
    );
    let access = res.data.data.access;
    return access;
  } catch (error: any) {
    return false;
  }
};

export const getexcelFirstRowData = async (
  WACID:any,
  setExcelFirstRow:(data: any) => void,
  setExcelFirstRowFromApi:(data: any) => void
) => {
 try {
  const res = await axiosHandler.get("/marketingAutomation/getWhatsappTestMessageData", {
    params: {
      WACID:WACID
    }
  });
  setExcelFirstRow(res.data.data.firstRow)
  setExcelFirstRowFromApi(res.data.data.firstRow)
  return res?.data;
 } catch (error:any) {
  return error.response.data;
 }
}

export const requestWhatsappBroadcastDetailedReport = async (
  WACID: number,
  REQUESTEDBY: number,
  dispatcher: any,
  setShowReportPopup: any,
  setReportStartDate: any,
  setReportEndDate: any
) => {
  try {
    let body: any = {
      WACID,
      REQUESTEDBY
    };
    const res = await axiosHandler.post(
      "marketingAutomation/requestWhatsappBroadcastDetailedReport",
      body
    );
    dispatcher(showSnackbarAction(
      res.data.message,
      "success"
    ))
    setShowReportPopup(false);
    setReportStartDate("");
    setReportEndDate("");
    document.body.classList.remove("no-overflow");
    return;
  } catch (error: any) {
    dispatcher(showSnackbarAction(
      error.response.data.message,
      "error"
    ))
    return;
  }
};

export const requestWhatsappDispositionDetailedReport = async (
  WADTMID: number,
  WADTMIDDATE: string,
  REQUESTEDBY: number,
  dispatcher: any,
  setShowReportPopup: any,
  setReportSelectedDate: any,
) => {
  try {
    let body: any = {
      WADTMID,
      WADTMIDDATE,
      REQUESTEDBY
    };
    const res = await axiosHandler.post(
      "marketingAutomation/requestWhatsappDispositionDetailedReport",
      body
    );
    dispatcher(showSnackbarAction(
      res.data.message,
      "success"
    ))
    setShowReportPopup(false);
    setReportSelectedDate("");
    document.body.classList.remove("no-overflow");
    return;
  } catch (error: any) {
    dispatcher(showSnackbarAction(
      error.response.data.message,
      "error"
    ))
    return;
  }
};

export const fetchWhatsappDetailReportDropdown = async (
  activeMarketTab: string,
  reportStartDate: string,
  reportEndDate: string,
  reportSelectedDate: string,
  setDropdownValues: any,
) => {
  try {
    let params: any = {
      reportType: activeMarketTab,
      broadcastStartDate: reportStartDate,
      broadcastEndDate: reportEndDate,
      dispositionSelectedDate: reportSelectedDate,
    };
    const res = await axiosHandler.get(
      "marketingAutomation/fetchWhatsappDetailReportDropdown",
      {
        params
      }
    );
    setDropdownValues(res.data.data);
    return;
  } catch (error: any) {
    setDropdownValues([]);
    return;
  }
};

export const fetchDbConstants= async(
  type:any
)=>{
  try {

    const res = await axiosHandler.post("/constants/fetchDbConstants",{type:type});

    return res.data.data
    
  } catch (error:any) {
    console.error("error while fetching constants",error.message)
    return []
  }
}

export const createWhatsappTemplate = async (
  payload: any,
  dispatcher: any,
  history: any,
  setStep?: any
) => {
  try {
    const response = await axiosHandler.post('orgWiseTemplateCreation/createTemplateAndDispo', payload);
    const {step} = payload;
    if(step && step == 1){
      setStep(2);
    }else{
      dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        response?.data?.message ? response.data.message : "Success",
        "success"
      )
    );
      history.push("/whatsapptemplates");
    }
    return
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        error?.response?.data?.message ? error.response.data.message : "An error occured, please try again",
        "error"
      )
    );
    return

  }
}

export const editWhatsappTemplate = async (
  payload: any,
  dispatcher: any,
  history: any,
  setStep?: any
) => {
  try {
    const response = await axiosHandler.put('orgWiseTemplateCreation/editTemplateAndDispo', payload);
    const { step } = payload;
    if (step && step == 1) {
      setStep(2);
    } else {
      dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        response?.data?.message ? response.data.message : "Success",
        "success"
      )
    );
      history.push("/whatsapptemplates");
    }
    return
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(
        // "This Contact Number Already Exists",
        error?.response?.data?.message ? error.response.data.message : "An error occured, please try again",
        "error"
      )
    );
    return

  }
}

export const fetchAllWhatsappTemplates = async (
  page: number,
  limit: number,
  setWhatsappTemplatesData: any,
  setTotalCount: any,
) => {
  try {
    const res = await axiosHandler.get(
      "orgWiseTemplateCreation/fetchAllTemplateAndDispo",
      {
        params: {
          page,
          limit,
        },
      }
    );

    const whatsapptemplatesData = res?.data?.data?.templates ?? [];
    setWhatsappTemplatesData(whatsapptemplatesData);
    setTotalCount(res?.data?.data?.totalCount ?? 0);

    return;
  } catch (error: any) {
    setWhatsappTemplatesData([]);
    setTotalCount(0);
    return;
  }
};

export const deactivateWhatsappTemplate = async (
  payload: any,
  dispatcher: any,
  setTemplateDeactivateModal: any,
  refreshData: any,
  setRefreshData: any,
) => {
  try {
    const response = await axiosHandler.put('orgWiseTemplateCreation/inactiveTemplate', payload);
    dispatcher(
      showSnackbarAction(
        response?.data?.message ? response.data.message : "Success",
        "success"
      )
    );
    setTemplateDeactivateModal(false);
    setRefreshData(!refreshData);
    return;
  } catch (error: any) {
    dispatcher(
      showSnackbarAction(
        error?.response?.data?.message ? error.response.data.message : "An error occured, please try again",
        "error"
      )
    );
    return
  }
}

export const fetchDropdownValues = async (
  dropdownCategory: string,
  setDropdownData: any,
  params: object,
) => {
  try {
    const res = await axiosHandler.get("orgWiseTemplateCreation/fetchDropdownValues", {
      params: {
        dropdownCategory,
        ...params
      }
    });

    const dropdownData = res?.data?.data ?? [];
    setDropdownData(dropdownData);
    return dropdownData;
  } catch (error: any) {
    console.error("Error fetching dropdown values:", error.message);
    return [];
  }
};